const operatorProject = [
  {label: 'Платный', value: ''},
  {label: 'Бюджетный', value: ''}
]

export default operatorProject